import React from 'react';
import AppRoutes from './routes/Approutes';

function App() {
  return <AppRoutes />;
}

export default App;
